import CircularProgress from '@mui/material/CircularProgress';
import { SpinnerProps } from './Spinner.types';

export default function Spinner(props: SpinnerProps) {
    const { color, size, sx } = props;

    return <CircularProgress color={color} size={size} sx={sx} />;
}
